import { debounce as _debounce } from 'es-toolkit';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import gsap from 'gsap';

export default class Layout {

	constructor(options) {

		// OPTIONS
		this.defaults = {
			main: undefined,
			skip_intro: false
		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace = 'layout';

		this.main = this.options.main;

		// VARS (vanilla DOM)
		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

		this.init()

	}

	init() {

		// this.initMainMenu();
		// this.initSearch();
		// this.paintMenu( document.location.href );
		this.initMobile();
		// this.checkHash();

		this.debounceResize(true);
		setTimeout(() => this.onResize(), 17);

	}



	// -----------------------------------------------------------------[ RESIZE HANDLER ]--------------------------------------------------------------//
	debounceResize(b) {
		if (b) {
			// debounce resize
			this._debResize = _debounce(() => this.onResize(true), 17);
			window.addEventListener('resize', this._debResize);
			// Listen for orientation changes
			this._onOrientation = () => this.onOrientationChange();
			window.addEventListener('orientationchange', this._onOrientation, false);
		}
		else {
			if (this._debResize) {
				this._debResize.cancel && this._debResize.cancel();
				window.removeEventListener('resize', this._debResize);
			}
			if (this._onOrientation) {
				window.removeEventListener('orientationchange', this._onOrientation, false);
				this._onOrientation = null;
			}
		}
	}

	onOrientationChange() {
		//console.log( 'onOrientationChange');
		if (this.id_orient) clearTimeout(this.id_orient);
		this.id_orient = setTimeout(() => this.onResize(true), 77);
	}

	onResize(_b) {

		// Variables available for future layout calculations
		// let w = window.innerWidth || document.documentElement.clientWidth,
		// 	h = window.innerHeight || document.documentElement.clientHeight;

		// this class is used for layouts that need to be resized before revealed. For example .home-MAIN-promo (opacity=0 and resized opacity 1)
		this.body.classList.add('resized');
		//document.querySelector( '#background' ).style.height = this.window.innerHeight + 'px';

		// place any resize dependent code here, using w and h
	}



	/*
	clearAllMenuSelections() {
	}
	*/


	paintMenuURL(url) {
		const menus= Array.from(document.querySelectorAll('.menu')),
			menu_views 	= Array.from(document.querySelectorAll('.menu-view'));


		menus.push( ...menu_views );

		const current = 'current-menu-item';
		const unselected = 'state-all-unselected';

		//console.log( menus );


		menus.forEach((mnu, i) => {

			const lis = Array.from(mnu.querySelectorAll('li'));
			let found = false;

			// clear classes on all li
			lis.forEach(li => {
				li.classList.remove('current-menu-item', 'current-menu-parent', 'current-page-ancestor', 'current_page_item', unselected);
			});


			if ( location.origin + '/' !== url ){ // if it's not homepage
				// find which one is selected
				lis.forEach(li => {
					const a = li.querySelector('a');
					if (!a) return;
					const href = a.getAttribute('href');
					if (href === url /*|| url.indexOf( href ) !== -1*/ ) {
						li.classList.add(current);
						found = true;
					}
				});

			}

			// if there is no selection -> unselected
			if (!found) {
				lis.forEach(li => li.classList.add(unselected));
			}
		});

		// special cases ( mostly single templates, taxonomies and categories, sub-pages )
		if (this.body.classList.contains('single-project') || this.body.classList.contains( 'tax-project-category' ) ) {
			this.setMenuSelection( Array.from(document.querySelectorAll( '.desktop-menu' )), 0, current, unselected );
		}
	}

	setMenuSelection( menus, index, current, unselected) {
		menus.forEach((mnu, i) => {
			const lis = Array.from(mnu.querySelectorAll('li'));
			lis.forEach(li => {
				li.classList.remove(unselected);
			});
			lis[ index ].classList.add(current);
		});
	}


	//----------------------------------------------------------- MOBILE ---------------------------------------//


	initMobile() {
		const btn = document.querySelector('#mobile-menu-toggle');
		const close = document.querySelector('#mobile-panel-close');
		const bg 	= document.querySelector( '#menu-panel .bg' );
		if (btn) btn.addEventListener('click', (e) => this.toggleDrawerMobile(e));
		if (close) close.addEventListener('click', (e) => this.openDrawerMobile(false, e));
		if (bg) bg.addEventListener( 'click', (e) => this.openDrawerMobile(false, e));
	}

	toggleDrawerMobile(e) {
		if (e) e.preventDefault();
		this.openDrawerMobile(!this.body.classList.contains('menu-mobile-open'));
	}

	openDrawerMobile(b, e) {
		if (e) e.preventDefault();
		const scrollEl = document.querySelector('#menu-panel .content-wrap');
		//const openBtn = document.querySelector('#mobile-panel-open');
		//const closeBtn = document.querySelector('#mobile-panel-close');
		if (!scrollEl) return;
		if (b) {
			if (!this.body.classList.contains('menu-mobile-open')) {
				this.body.classList.add('menu-mobile-open');
				gsap.to(window, { duration: 0, scrollTo: 0 });
				disableBodyScroll(scrollEl);
				// Update ARIA attributes
				//if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
				//if (closeBtn) closeBtn.setAttribute('aria-expanded', 'true');
			}
		}
		else {
			if (this.body.classList.contains('menu-mobile-open')) {
				this.body.classList.remove('menu-mobile-open');
				enableBodyScroll(scrollEl);
				// Update ARIA attributes
				//if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
				//if (closeBtn) closeBtn.setAttribute('aria-expanded', 'false');
			}
		}
	}


	/*
	initMobileSearch(){
		const s = document.querySelector('#drawer-mobile .search');
		const input = document.querySelector('#drawer-mobile .searchfield');
		if (!s || !input) return;
		s.addEventListener('click', () => {
			document.querySelector('#drawer-mobile').classList.add('activate-search');
			input.focus();
		});
		input.addEventListener('blur', () => {
			document.querySelector('#drawer-mobile').classList.remove('activate-search');
		});
	}
	*/

	/*
	resetMobileMenu(){
		const items = Array.from(document.querySelectorAll('#menu-mobile-menu > li'));
		items.forEach(li => {
			if (li.classList.contains('menu-item-has-children')) {
				const a = li.querySelector('> a');
				if (a && a.dataset.open) {
					a.click();
				}
			}
		});
		const scrollPanel = document.querySelector('#scroll-panel');
		if (scrollPanel) scrollPanel.scrollTop = 0;
	}
	*/



	onBarbaChangeState(state, data) {
		switch (state) {
			case 'before':
				
				//this.openDesktopMenu( false );
				//this.openDrawerMobile( false );
				break;
			case 'beforeEnter':
			
				this.paintMenuURL(document.location.href);
				this.onResize();
				break;
			case 'after':
				// this.checkHash();
				break;
		}
	}

}
